import { SYSBaseElement, html } from "../../../../../../../_ovlclient/src"

import { T } from "../../../../../../../_ovlclient/src/global/globals"
import type { SYSState } from "../../../../../../../_ovlclient/src"
import { FeatureGet } from "../../../../../../../_ovlclient/src/global/globalapi"
import type { KPIContainerProps } from "../../../features/kpi/kpicontainer"

export type DashboardState = {}

export class CompDashboard extends SYSBaseElement {
  async getUI() {
    if (!this.state.ovl.app.ready) {
      return
    }
    let partner = this.state.app.global.DAT.partner

    return html`
      <div class="ovl-smart-screen-margins">
        <div class="dashboardgrid">
          <div class="fd-layout-panel dash-title">
            <div class="fd-layout-panel__header">
              <div class="fd-layout-panel__head">
                <p class="fd-layout-panel__title fd-has-type-2">
                  ${T("GENWelcome", [
                    this.state.ovl.user.firstName,
                    this.state.ovl.user.lastName,
                    this.state.ovl.user.cardName,
                  ])}
                </p>
              </div>
            </div>
          </div>

          <div class="fd-layout-panel dash-mainattachments">
            <comp-filelist
              .props=${(s: SYSState) => {
                return {
                  fileList: s.app.global.DAT.partner.mainAttachments.files,
                  title: T("GENMainAttachmentTitle"),
                }
              }}
            ></comp-filelist>
          </div>

          <div
            class="fd-layout-panel dash-partnerattachments"
          >
            <comp-filelist
              .props=${(s: SYSState) => {
                return {
                  fileList: s.app.global.DAT.partner.partnerAttachments.files,
                  title: T("GENPartnerAttachmentTitle"),
                }
              }}
            >
            </comp-filelist>
          </div>

          <div class="fd-layout-panel dash-salescontact">
            <div class="fd-layout-panel__header ">
              <div class="fd-layout-panel__head">
                <h3 class="fd-layout-panel__title">
                  ${T("GENContactSalesTitle")}
                </h3>
              </div>
            </div>
            <div class="fd-layout-panel__body">
              <img
                src=${`data:image/jpg;base64,${this.state.app.global.GEN.pics.salesContact}`}
              />
              <p class="fd-layout-panel__description">
                <b
                  >${partner.salesContact.firstName}
                  ${partner.salesContact.lastName}</b
                >
              </p>
              <p class="fd-layout-panel__description">
                ${partner.salesContact.phone}
              </p>
              <p class="fd-layout-panel__description">
                ${partner.salesContact.email}
              </p>
            </div>
          </div>
        </div>
        <comp-kpicontainer
          .props=${{ type: "Dashboard" } as KPIContainerProps}
        ></comp-kpicontainer>
      </div>
    `
  }
}
